export default "__VITE_ASSET__ab26754a__"